import { __rest } from "tslib";
import React from 'react';
import { ModalCard } from './layout/ModalCard';
import { ModalCloseIcon } from './layout/ModalCloseIcon';
import { ModalContent } from './layout/ModalContent';
import { ModalFooter } from './layout/ModalFooter';
import { ModalHeader, ModalTitle } from './layout/ModalHeader';
/** Simplified Modal layout for everyday use */
export const ModalLayout = (_a) => {
    var { children, accent, header, footer, closeIcon } = _a, rest = __rest(_a, ["children", "accent", "header", "footer", "closeIcon"]);
    return (React.createElement(ModalCard, Object.assign({}, rest),
        React.createElement(ModalHeader, { accent: accent },
            React.createElement(ModalTitle, null, header),
            " ",
            closeIcon && React.createElement(ModalCloseIcon, null)),
        React.createElement(ModalContent, { accent: accent }, children),
        React.createElement(ModalFooter, { accent: accent }, footer)));
};
//# sourceMappingURL=ModalLayout.js.map